class ValleansCartCarousel extends HTMLElement {
  #abortController = new AbortController();
  #resizeObserver = null;

  connectedCallback() {
    if (this.#abortController.signal.aborted) {
      this.#abortController = new AbortController();
    }
    const rail = this.querySelector('[data-vh-cart-rail]');
    const previous = this.querySelector('[data-vh-cart-prev]');
    const next = this.querySelector('[data-vh-cart-next]');

    if (!(rail instanceof HTMLElement) || !(previous instanceof HTMLButtonElement) || !(next instanceof HTMLButtonElement)) {
      return;
    }

    this.rail = rail;
    this.previousButton = previous;
    this.nextButton = next;

    const { signal } = this.#abortController;
    previous.addEventListener('click', () => this.scrollByDirection(-1), { signal });
    next.addEventListener('click', () => this.scrollByDirection(1), { signal });
    rail.addEventListener('scroll', () => this.updateControls(), { signal, passive: true });

    this.#resizeObserver = new ResizeObserver(() => this.updateControls());
    this.#resizeObserver.observe(rail);

    requestAnimationFrame(() => this.updateControls());
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#resizeObserver?.disconnect();
  }

  scrollByDirection(direction) {
    if (!this.rail) return;

    const firstCard = this.rail.querySelector('.vh-cart-upsell__card');
    const cardWidth = firstCard instanceof HTMLElement ? firstCard.getBoundingClientRect().width : 0;
    const styles = getComputedStyle(this.rail);
    const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
    const fallback = Math.max(this.rail.clientWidth * 0.82, 1);
    const distance = cardWidth > 0 ? (cardWidth + gap) * Math.max(1, Math.floor(this.rail.clientWidth / (cardWidth + gap))) : fallback;

    this.rail.scrollBy({
      left: direction * distance,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  updateControls() {
    if (!this.rail || !this.previousButton || !this.nextButton) return;

    const maxScroll = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
    const hasOverflow = maxScroll > 2;
    const current = this.rail.scrollLeft;

    this.toggleAttribute('data-scrollable', hasOverflow);
    this.previousButton.hidden = !hasOverflow;
    this.nextButton.hidden = !hasOverflow;
    this.previousButton.disabled = !hasOverflow || current <= 2;
    this.nextButton.disabled = !hasOverflow || current >= maxScroll - 2;
  }
}

if (!customElements.get('valleans-cart-carousel')) {
  customElements.define('valleans-cart-carousel', ValleansCartCarousel);
}
